import Dashboard from "../Views/Pages/Admin";
import AdminLayout from "../Shared-ui/Layout/AdminLayout";
import AdminGuard from "../Shared-ui/utils/Routes/AdminGuard";
import AdminRoles from "../Views/Pages/AdminRoles";
import AdminSubscription from "../Views/Pages/AdminSubscription";
import AuditLog from "../Views/Pages/AdminAuditLog";
import AdminModels from "../Views/Pages/AdminModels";
import { UserContextProvider } from "../Shared-ui/Context/UserContext";
import AdminUserManagement from "../Views/Pages/AdminUsers";
import AdminOrganization from "../Views/Pages/AdminOrganization";
import AdminGroups from "../Views/Pages/AdminGroups";
// const DashBoard = React.lazy(() => import('../Views/Pages/Dashboard'));

const AdminRoute = {
  // path: '/',
  element: (
    <>
      <UserContextProvider>
        <AdminGuard>
          <AdminLayout />
        </AdminGuard>
      </UserContextProvider>
    </>
  ),
  children: [
    {
      path: "/admin",
      element: (
        <>
          <AdminUserManagement />
        </>
      ),
    },
    {
      path: "/subscription",
      element: (
        <>
          <AdminSubscription />
        </>
      ),
    },
    {
      path: "/roles",
      element: (
        <>
          <AdminRoles />
        </>
      ),
    },
    // {
    //   path: "/users",
    //   element: (
    //     <>
    //       <AdminUserManagement />
    //     </>
    //   ),
    // },
    {
      path: "/models",
      element: (
        <>
          <AdminModels />
        </>
      ),
    },
    {
      path: "/audit-log",
      element: (
        <>
          <AuditLog />
        </>
      ),
    },
    {
      path: "/admin/organization",
      element: (
        <>
          <AdminOrganization />
        </>
      ),
    },
    {
      path: "/admin/teams",
      element: (
        <>
          <AdminGroups />
        </>
      ),
    },
  ],
};

export default AdminRoute;
